
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Obwohl der tiefenpsychologischen Traumdeutung heute kein grosser Wert beigemessen wird, raten viele Therapeuten, ein Traumtagebuch zu führen. Glaubt man gewissen Überlieferungen, dann haben viele Künstler, Wissenschaftler und Schriftsteller ihre nächtlichen Abenteuer für sich und ihre Werke nutzen können. Der Schriftsteller Arthur Schnitzler führte seit seinem 13. Lebensjahr ein Traumtagebuch, in dem er säuberlich sowohl den Inhalt seiner Träume festhielt als auch den emotionalen Zustand, in dem er sich beim Träumen befand. Schnitzler war davon überzeugt, dass er dadurch einen besseren Zugang zu seinem Unterbewusstsein bekam, und dass ihm dies beim Schreiben half. `}<br /><br />{`
Wie festgehaltene Träume kreative Menschen beeinflussen, wurde schon oft beschrieben. So setzte der Maler Salvador Dalí seine Traumsequenzen in seinen fantastischen Bildern um. Aber auch die Regisseure Alfred Hitchcock, Ingmar Bergman, Carlos Saura oder Federico Fellini liessen sich von ihren inneren Traumwelten inspirieren. `}<M mdxType="M">{`Paul McCartney soll die Melodie von «Yesterday» im Traum eingefallen sein.`}</M>{` Er kritzelte die geträumten Noten jedoch nicht in ein Tagebuch, sondern stürzte sich sogleich ans Klavier, um die Melodie zu sichern.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;